import { useEventListener } from './useEventListener';

export const useBeforeUnload = ({
  beforeUnload,
}: {
  beforeUnload: () => void;
}) => {
  const handleBeforeUnload: EventListener = (e) => {
    e.preventDefault();

    beforeUnload();
  };

  useEventListener(window, 'beforeunload', handleBeforeUnload);
};
